(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

//NEED TO GET ZIP AND STATE FROM START FORM?

var zip, dealerData, stateData, countryData;

$(document).ready(function (e) {

	var currentUrl = window.location.href;
	var facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl,
	    twitterUrl = 'https://twitter.com/home?status=Check out my custom Airstream Travel Trailer!+' + currentUrl,
	    linkedinUrl = 'https://www.linkedin.com/shareArticle?mini=true&amp;url=' + currentUrl;
	$('#facebookShare').attr('data-link', facebookUrl);
	$('#twitterShare').attr('data-link', twitterUrl);
	$('#linkedinShare').attr('data-link', linkedinUrl);

	$('#facebookShare').attr('href', facebookUrl);
	$('#twitterShare').attr('href', twitterUrl);
	$('#linkedinShare').attr('href', linkedinUrl);

	$("#smsShare").hover(function () {
		$(this).children('img').attr('src', '/wp-content/themes/airstream-2018/assets/dist/images/Airstream_SocialLinks_Message_Circle.Green.svg');
	}, function () {
		$(this).children('img').attr('src', '/wp-content/themes/airstream-2018/assets/dist/images/Airstream_SocialLinks_Message_Circle.Gray.svg');
	});

	$("#emailShare").hover(function () {
		$(this).children('img').attr('src', '/wp-content/themes/airstream-2018/assets/dist/images/Airstream_SocialLinks_Email_Circle.Orange.svg');
	}, function () {
		$(this).children('img').attr('src', '/wp-content/themes/airstream-2018/assets/dist/images/Airstream_SocialLinks_Email_Circle.Gray.svg');
	});

	$("#facebookShare").hover(function () {
		$(this).children('svg').children('path.background').attr('fill', '#547bbd');
	}, function () {
		$(this).children('svg').children('path.background').attr('fill', '#b1b3b3');
	});

	$("#twitterShare").hover(function () {
		$(this).children('svg').children('path.cls-1').attr('fill', '#79ccf0');
	}, function () {
		$(this).children('svg').children('path.cls-1').attr('fill', '#b1b3b3');
	});

	$("#linkedinShare").hover(function () {
		$(this).children('svg').children('path.background').attr('fill', '#1385c8');
	}, function () {
		$(this).children('svg').children('path.background').attr('fill', '#b1b3b3');
	});

	var smsLink = 'sms:?body=Check out the Airstream I just configured! ' + currentUrl;
	var emailLink = 'mailto:?body=Check out the Airstream I just configured! ' + currentUrl + '&subject=My Airstream Travel Trailer';
	$('#smsShare').attr('href', smsLink);
	$('#emailShare').attr('href', emailLink);

	$('.copyLink').attr('data-link', window.location.href);

	$('.copyLink').click(function (e) {
		$(this).text("Copied!");
		var text = $(this).attr('data-link');
		navigator.clipboard.writeText(text).then(function () {
			console.log('Async: Copying to clipboard was successful!');
		}, function (err) {
			console.error('Async: Could not copy text: ', err);
		});
	});

	//get config info
	var params = new URLSearchParams(window.location.search);

	var configData = JSON.parse(localStorage.getItem('configData'));
	zip = '45334';

	if (configData != null && configData.zip) {
		zip = configData.zip;
	}

	if (params.has('zip')) {
		zip = params.get('zip');
	}

	if (configData != null && configData.firstName && configData.firstName != '') {
		var firstName = configData.firstName;
		var nameLen = firstName.length;
		var firstNamePos = firstName + "'s";

		if (firstName.substring(nameLen) == "s") {
			firstNamePos = firstName + "'";
		}

		$('#cust-name').text(firstNamePos);
		$('.uname').text(firstName);
		$('.uname').parent().after(', your ');
	} else {
		$('#cust-name').text('Your');
		$('.uname').text('Your ');
	}

	/*if(params.has('zip')){
 	zip = decodeURIComponent(params.get('zip'));
 }*/

	var accessToken = 'pk.eyJ1IjoiYmFydGhvbG9tZXdmaXNoMjk4MyIsImEiOiJjaW84ampjZ2EwMnRhdnpsejdpNXU0NG1wIn0.8U2l4oNvAzzPMN_yavGRKw';

	mapboxgl.accessToken = accessToken;
	L.mapbox.accessToken = accessToken;
	var geoCoder = L.mapbox.geocoder('mapbox.places');

	$.get('/wp-content/themes/airstream-2018/templates/tool-locate/stateData.json', function (data) {
		stateData = data;
		$.get('/wp-content/themes/airstream-2018/templates/tool-locate/countryData.json', function (data) {
			countryData = data;
			$.get('https://airhub.airstream.com/dealer', function (data) {
				dealerData = data;
				geoCoder.query(zip, processResults);
			});
		});
	});

	$('#contactDlrBtn').click(function (e) {
		e.preventDefault();
		$('.quote-modal').show();
		setHubspotFields();
	});

	$('.pl-modal-close').click(function (e) {
		e.preventDefault();
		$('.pl-modal').hide();
	});

	$('.pl-shareBtn, .pl-sticky-tab-share, .pl-mobileShareBtn').click(function (e) {
		$('.pl-share-modal').show();
	});
	//console.log(window.location.href);
	$('#share-url').val(window.location.href);

	//geoCoder.query(zip, processResults);

	// var geoResponse = $.get('https://api.mapbox.com/geocoding/v5/mapbox.places/' + zip + '.json?access_token=' + accessToken, function(data){
	// 	console.log(data.features);
	// });

	//L.mapbox.map('map').setView()

	//var geoResults = geocoderControl.query(zip);

	//console.log(geoResults);
});

function processResults(err, data) {
	var result = false;

	for (var y = 0; y < data.results.features.length; y++) {
		if (data.results.features[y].text == zip && data.results.features[y].place_name.includes("United States")) {
			result = data.results.features[y];
		}
	}

	if (!result) {
		$('.pl-dealer-name').text("We couldn't find any dealers matching your zip code.");
		$('.pl-dealer-address').html('<span>You can use our official <a href="/dealers" target="_blank">Dealer Locator tool</a> to find a dealer. Or, if you\'re outside the US, view our <a href="/company/country" target="_blank">Global Dealers</a></span>');
		$('.pl-map-overlay-nav').hide();
		return;
	}

	if (result.place_type.includes('region')) {
		locateDealer(stateData, result, dealerData);
	} else {
		locateDealer(countryData, result, dealerData);
	}
}

function locateDealer(bounds, currentResult, dealerData) {
	var searchWithin;

	$.each(bounds.features, function (index, feature) {
		//console.log(currentResult.place_name + ' = ' + feature.properties.name);
		if (currentResult.place_name.indexOf(feature.properties.name) !== -1) {
			searchWithin = {
				'type': 'FeatureCollection',
				'features': [feature]
			};
		}
	});

	var point = turf.point(currentResult.geometry.coordinates);
	var dataCopy = $.extend(true, {}, dealerData);
	var fc = turf.featureCollection(dataCopy.features);
	var within = turf.within(fc, searchWithin);
	var results = {
		'type': 'FeatureCollection',
		'features': []
	};
	var options;
	var center;
	var chosenIndex;

	if (!within.features.length) {
		alert('No dealers matched your search.');
		this.reset();
		return;
	}

	resultsLength = 1;
	if (currentResult.place_type.includes('region')) {
		resultsLength = within.features.length;
	}

	// get 3 closest dealers if city or zip
	// if state, get all dealers in state
	for (var i = 0; i < resultsLength; i++) {
		var nearest = turf.nearest(point, within);
		results.features.push(nearest);
		$.each(within.features, function (index, feature) {
			if (nearest.geometry.coordinates !== feature.geometry.coordinates) return true;
			chosenIndex = index;
			return false;
		});
		within.features.splice(chosenIndex, 1);
	}

	center = turf.center(results);

	var map = new mapboxgl.Map({
		container: 'map',
		style: 'mapbox://styles/bartholomewfish2983/cipu6eel90000bim1s6ndtpzx'
	});

	for (var f in results.features) {
		if (!results.features.hasOwnProperty(f)) continue;
		var distance = turf.distance(point, results.features[f], 'miles');
		results.features[f].properties.distance = distance;
		addDealerPin(f, results.features[f], map);
	}
}

function addDealerPin(index, feature, map) {
	// add markers to map
	// create an img element for the marker
	var el = document.createElement('button');
	el.className = 'marker h4 white button-reset';
	el.style.backgroundImage = 'url(/wp-content/themes/airstream-2018/assets/dist/images/Pin_plainW.Symbol.svg)';
	el.style.width = '50px';
	el.style.height = '61px';
	el.style.top = '-61px';
	el.style.left = '-25px';
	el.style.padding = '0px';
	el.setAttribute('data-id', feature.properties.id);

	$('.pl-dealer-name').text(feature.properties.name);
	$('.pl-dealer-address').html('<span>' + feature.properties.address1 + '</span><span>' + feature.properties.city + ', ' + feature.properties.state + ' ' + feature.properties.zip + '</span><span>' + feature.properties.phone + '</span>');
	var isFiveRivet = feature.properties.isFiveRivet;
	if (isFiveRivet) {
		$('.pl-form-rivet-logo').show();
	}

	//el.addEventListener('click', this.highlightResult.bind(this))

	// add marker to map
	new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(map);

	var offset = [0, $('#map').outerHeight() / 2];

	if (window.innerWidth >= 992) {
		offset = [$('#map').outerWidth() / 3.5, 0];
	}

	options = {
		center: feature.geometry.coordinates,
		offset: offset,
		zoom: 9
	};

	map.flyTo(options);
}

},{}]},{},[1]);
